// OPTIONS SELECTORS
let option1 = document.querySelectorAll("[name=option1]");
let option2 = document.querySelectorAll("[name=option2]");
let option3 = document.querySelectorAll("[name=option3]");

//FORM INPUT
let variantId = document.querySelector("[name=id]"); // ID
let productQuantity = document.querySelector("[name=quantity]"); //QUANTITY
let productBarcode = document.getElementById("barcode"); // _BARCODE

// INPUT
let quantitySelector = document.querySelector("[data-quantity-selector]");

//TEXT HTML
let sizeText = document.querySelectorAll("[data-product-size]");
let specifics = document.querySelectorAll("[data-specs]");
let productPrice = document.querySelectorAll("[data-product-price]");
let compareProductPrice = document.querySelectorAll(
  "[data-product-compare-price]"
);
let comparePriceContainer = document.querySelectorAll(".product-compare-price");

// CONTAINERS
let productPriceContainer = document.querySelectorAll(".product-price");

// BUTTONS
let addToCartButton = document.querySelectorAll("[data-add-to-cart]"); // ADD TO CART BUTTON
let goToCustomButton = document.querySelectorAll(".product-option-button"); //GO TO CUSTOM PRODUCT BUTTON
let cartCustomButton = document.querySelectorAll(
  "[data-add-bundle-custom-cart]"
); // CART CUSTOM BUNDLE BUTTON

// MEDIA
let thumbnail = document.querySelectorAll("[data-product-media-thumbnail]");
let floatingFeaturedImage = document.getElementById("floating__image"); // FLOATING IMAGE
let productFeaturedContainer = document.querySelector(".featured__media");
let productFeaturedSource = document.querySelectorAll(
  "[data-featured-media] source"
);
let productPhotoImage = document.getElementById("ProductPhotoImg");
let initialPhoto = productPhotoImage.src;

// PRODUCT JSON DATA
var addData = {
  id: variantId.value,
  quantity: productQuantity.value,
  properties: {
    _barcode: productBarcode.value,
    _custom: null,
  },
};

//SELECTION
let selectedOption = {
  option1: currentVariant.option1,
  option2: currentVariant.option2,
  option3: currentVariant.option3,
};

let selectedProductVariant;

// LISTENER
productPhotoImage.addEventListener("load", () => {
  productFeaturedContainer.style.opacity = 1;
});

// OPTION SELECTORS => CHANGE VALUE OF VARIABLE [selectedOption]
option1.forEach((option) => {
  option.addEventListener("change", function () {
    selectedOption.option1 = this.value;
    if (this.checked) selectedOption.option1 = this.value;
    changeVariant(selectedOption);
  });
});

option2.forEach((option) => {
  option.addEventListener("change", function () {
    selectedOption.option2 = this.value;
    if (this.checked) selectedOption.option2 = this.value;
    changeVariant(selectedOption);
  });
});

option3.forEach((option) => {
  option.addEventListener("change", function () {
    selectedOption.option3 = this.value;
    if (this.checked) selectedOption.option3 = this.value;
    changeVariant(selectedOption);
  });
});

// INITIALIZE
for (let i = 0; i < productVariants.length; i++) {
  if (
    selectedOption.option1 == productVariants[i].option1 &&
    selectedOption.option2 == productVariants[i].option2 &&
    selectedOption.option3 == productVariants[i].option3
  ) {
    updateSelectorQuantity(productVariants[i]);
    updateSpecs(productVariants[i]);
    updateNotifyMe(productVariants[i]);
    updateCustomHref(productVariants[i]);
    updateSelectedVariant(productVariants[i]);
    break;
  }
}

//FIND VARIANT FROM PRODUCT
function changeVariant(options) {
  for (let i = 0; i < productVariants.length; i++) {
    if (
      options.option1 == productVariants[i].option1 &&
      options.option2 == productVariants[i].option2 &&
      options.option3 == productVariants[i].option3
    )
      return onSelectChange(productVariants[i]);
  }
}

// FUNCTIONS
function getProductQuantityInCart(variant) {
  let cartProductQuantity = 0;

  cartInfo.forEach((item) => {
    if (item.variant_id == variant.id) cartProductQuantity += item.quantity;
  });

  return cartProductQuantity;
}

function updateUrl(id) {
  const url = new URL(window.location);
  url.searchParams.set("variant", id);
  window.history.replaceState({}, "", url);
}

function updateMainImage(image) {
  if (image.featured_image) {
    if (initialPhoto !== image.featured_image) {
      productFeaturedContainer.style.opacity = 0.5;
      initialPhoto = image.featured_image;
    }

    productFeaturedSource.forEach((source) => {
      source.srcset = `${image.featured_image}&width=${source.width} 1x,${
        image.featured_image
      }&width=${source.width * 2} 2x `;
    });

    floatingFeaturedImage.src = image.featured_image + "&width=100";
  } else
    productFeaturedSource.src =
      "//cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_95x95@2x.gif";
}
function updateMedia(color) {
  thumbnail.forEach((element) => {
    if (element.alt == color || element.alt == "all")
      element.style.display = "block";
    else element.style.display = "none";
  });
}

function updatePrice(price) {
  productPrice.forEach((el) => {
    el.textContent = formatter.format(price.price / 100);
    el.dataset.productPrice = price.price;
  });
}
function updateComparePricing(price) {
  if (price.compare_at_price > price.price && price.compare_at_price) {
    compareProductPrice.forEach((el) => {
      el.textContent = formatter.format(price.compare_at_price / 100);
      el.dataset.productPrice = price.compare_at_price;

      productPriceContainer.forEach((e) => {
        e.classList.add("compare");
      });
    });
  } else {
    productPriceContainer.forEach((e) => {
      e.classList.remove("compare");
    });
  }
}
function updateSelectorQuantity(inventory) {
  let currentCartInventory = getProductQuantityInCart(inventory);
  let optionMaker = "";
  let quantityIn = 1;

  if (inventory.inventory_policy == "deny") {
    //INVENTORY CHECKER
    quantityIn = inventory.inventory - currentCartInventory;

    for (let i = 1; i <= quantityIn; i++) {
      if (i > 30) break;
      optionMaker += `<option value='${i}'>${i}</option>`;
    }

    if (quantityIn <= 0) {
      optionMaker += `<option>1</option>`;
      disableAddToCartButton();
    } else {
      enableAddToCartButton();
    }

    quantitySelector.innerHTML = optionMaker;
  }
  if (inventory.inventory_policy == "continue") {
    //INVETORY POLICY [CONTINUE] TO BUY EVEN IF LESS THAN ZERO
    for (let i = 1; i <= 10; i++) {
      optionMaker += `<option value='${i}'>${i}</option>`;
    }
    quantitySelector.innerHTML = optionMaker;
    enableAddToCartButton();
  }
}
function updateNotifyMe(inventory) {
  let notifyMeBtn = document.querySelectorAll(".osf__container ");

  if (notifyMeBtn)
    notifyMeBtn.forEach((btn) => {
      if (inventory.inventory <= 0) btn.style.display = "block";
      else btn.style.display = "none";
    });
}
function updateProductBarcode(variant) {
  productBarcode.value = variant.barcode;
}
function updateCustomHref(variant) {
  const productNotice = document.querySelector(".product-notice");

  document.querySelectorAll("[data-custom-product-link]").forEach((e) => {
    if (variant.custom == false) {
      e.href = `/products/custom-${variant.sku}?customvariantid=${variant.id}&barcode=${variant.barcode}&pr=${variant.price}&limit=${variant.inventory}`;
      e.style.display = "block";

      if (productNotice) productNotice.style.display = "block";
    } else {
      e.style.display = "none";
      if (productNotice) productNotice.style.display = "none";
    }
  });
}

function updateSelectedVariant(variant) {
  selectedProductVariant = variant;
}

function updateSpecs(variant) {
  specifics[1].textContent = variant.sku;
  specifics[2].textContent = variant.size_classification;
  specifics[3].textContent = variant.target;
  specifics[4].textContent = variant.measurement;
  specifics[5].textContent = variant.weight;
  specifics[6].textContent = variant.material;
  specifics[7].textContent = variant.method;
  specifics[8].textContent = variant.color;
  specifics[9].textContent = variant.usage;
  specifics[10].textContent = variant.accessories;
  sizeText.forEach((size) => {
    size.textContent = variant.size_classification;
  });
}

function enableAddToCartButton() {
  addToCartButton.forEach((button) => {
    if (!productRelease) button.textContent = productComingSoonTxt;
    else {
      button.textContent = productInStockTxt;
      button.classList.remove("disabled");
      button.removeAttribute("disabled");
      goToCustomButton.forEach((button) => {
        button.classList.remove("disabled");
      });
      cartCustomButton.forEach((button) => {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
      });
    }
  });
}

function disableAddToCartButton() {
  addToCartButton.forEach((button) => {
    if (!productRelease) button.textContent = productComingSoonTxt;
    else button.textContent = productSoldOutTxt;

    button.classList.add("disabled");
    button.setAttribute("disabled", "");
  });
  goToCustomButton.forEach((button) => {
    button.classList.add("disabled");
    button.setAttribute("href", "#");
  });
  cartCustomButton.forEach((button) => {
    button.classList.add("disabled");
    button.setAttribute("disabled", true);
  });
}

//VARIANT SELECTOR CHANGES AFTERMATH [MAIN SWITCH]
function onSelectChange(variant) {
  variantId.value = variant.id; //update FORM input[value='id']
  updateUrl(variant.id); //update URL
  updateMainImage(variant); //update main image
  updateMedia(variant.option1); //update thumbnail
  updateProductBarcode(variant); //update barcode
  updatePrice(variant); //update price
  updateComparePricing(variant); //update compare Pricing
  updateSelectorQuantity(variant); //update selector quantity
  updateCustomHref(variant); //update custom product href

  updateSelectedVariant(variant); //update selectedVariant

  if (specifics[1]) updateSpecs(variant); //update specs text
  updateNotifyMe(variant); // ORDERSIFY APP BUTTON
}

/*******************************/
// UPDATE MAIN IMAGE WHEN THUMBNAIL IS CLICKED

let thumbnailSelection = document.querySelector(".thumbnail"); //THUMBNAILS

if (thumbnailSelection)
  thumbnailSelection.addEventListener("click", (e) => {
    if (e.target.dataset.productMediaThumbnail == "") {
      if (initialPhoto !== e.target.src) {
        productFeaturedContainer.style.opacity = 0.5;
        initialPhoto = e.target.src;
      }

      productFeaturedSource.forEach((src) => {
        src.srcset = `${e.target.src.replace(
          "&width=100",
          "&width=" + src.width
        )} 1x,${e.target.src.replace(
          "&width=100",
          "&width=" + src.width * 2
        )} 2x `;
      });
    }
  });

/*******************************/

// RERENDER ALL PRODUCT PRICE ea. Y1000
function multiplyPricing(value) {
  productPrice.forEach((el) => {
    el.textContent = formatter.format((el.dataset.productPrice / 100) * value);
  });
  compareProductPrice.forEach((el) => {
    el.textContent = formatter.format(
      (el.dataset.productComparePrice / 100) * value
    );
  });
}

//UPDATE VALUES OF input[quantity]
quantitySelector.addEventListener("change", function () {
  multiplyPricing(quantitySelector.value);
  productQuantity.value = quantitySelector.value;
});

/*******************************/
// FORM ADD TO CART
const form = document.getElementById("productForm");
let customProduct = document.getElementById("customProduct");
let mainFeaturedMedia = document.querySelector(".main-featured-media");

// ADDITIONALS TO ADD TO CART
function additionalsToCart() {
  console.log("additionalsToCart");

  const selectedVariantTitle = selectedProductVariant.title;
  console.log(`selectedVariantTitle ${selectedVariantTitle}`);

  const selectedVariantSku = selectedProductVariant.sku;
  console.log(`selectedVariantSku ${selectedVariantSku}`);

  let naireProperty = {
    文字エリアB行数: "1行",
    文字エリアB: "JFL※指定ロゴ※",
    _CustomTarget: selectedVariantSku,
  };

  if (selectedVariantTitle !== "無し") {
    naireProperty = {
      文字エリアA行数: "1行",
      文字エリアA: `${selectedVariantTitle}※指定ロゴ※`,
      ...naireProperty,
    };
  }

  const cpbSkuToVariantId = {
    "ADF500-BLANK": 51015828144446,
    "ADF500-SHIGA": 51015831716158,
    "ADF500-MIE": 51016243708222,
    "ADF500-OITA": 51016261173566,
    "ADF500-HONDA": 51016291746110,
    "ADF500-URAYASU": 51016325136702,
    "ADF500-AOMORI": 51016355381566,
    "ADF500-SHINJUKU": 51016396603710,
    "ADF500-YOKOGAWA": 51016418984254,
    "ADF500-MINEBEA": 51016438055230,
    "ADF500-ASUKA": 51016459092286,
  };

  const cpbVariantId = cpbSkuToVariantId[selectedVariantSku];

  let formData = {
    items: [
      {
        id: cpbVariantId,
        quantity: productQuantity.value,
        properties: naireProperty,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      form.submit();
    });
}

function additionalsToCartPelada() {
  // 本番のステッカー
  const presentVariantId = 51434421682494;

  // BPのステッカー
  // const presentVariantId = 45293991493783;

  let formData = {
    items: [
      {
        id: presentVariantId,
        quantity: productQuantity.value,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log(data);
      form.submit();
    });
}

addToCartButton.forEach((btn) => {
  btn.addEventListener("click", function () {
    btn.setAttribute("disabled", "");

    let pageUrl = window.location.href;

    const JFLProductHandles = ["products/adf500jfl", "products/af580jfl"];
    const isJFL = JFLProductHandles.some((handle) => pageUrl.includes(handle));

    const peladaProductHandles = [
      "products/f5k5000",
      "products/f5k5001",
      "products/f5k4000",
      "products/f5k3000",
      "products/f4k5000",
      "products/f4k4000",
      "products/f4k3000",
      "products/f9k4000",
      "products/f9k3000",
      "products/f3k9200",
      "products/f5k9100",
      "products/f5k9200",
      "products/f5k9300",
    ];
    const isPelada = peladaProductHandles.some((handle) =>
      pageUrl.includes(handle)
    );

    if (isJFL) additionalsToCart();
    else if (isPelada) additionalsToCartPelada();
    else form.submit();
  });
});

/*******************************/
// FLOATING BAR HIDE & SHOW
let floatAddBtn = document.getElementById("float-add");
let floatBuyBtn = document.getElementById("float-buy");

floatAddBtn.addEventListener("click", () => {
  floatAddBtn.classList.toggle("active");
  floatBuyBtn.classList.toggle("active");
});

/*******************************/

// RENDER FEATURED PRODUCTS
const renderLoadObserver = new IntersectionObserver((entries) => {
  if (!entries[0].isIntersecting) return;

  let parent = entries[0].target;
  let target = parent.querySelector("template");
  let template = target.content.cloneNode(true);
  target.after(template);
  renderLoadObserver.unobserve(productFeaturedSetContainer);
  setTimeout(() => {
    parent.classList.add(parent.id + "--active");
  }, 1000);
});

let productFeaturedSetContainer = document.getElementById(
  "product-featured-set"
);
if (productFeaturedSetContainer)
  renderLoadObserver.observe(productFeaturedSetContainer);

/*******************************/

// CART BUNDLE CUSTOM
if (cartCustomButton)
  cartCustomButton.forEach((button) => {
    if (!customBundleCart) return;

    let formData = { items: [] };

    button.addEventListener("click", () => {
      button.setAttribute("disabled", true);
      button.classList.add("disabled");

      const cartSet = customBundleCart.find((v) =>
        v.sku.includes(selectedProductVariant.sku)
      );

      if (!cartSet) return;

      cartSet.product_id.forEach((i) =>
        formData.items.push({
          id: i,
          quantity: quantitySelector.value,
        })
      );

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);

          if (data.description) {
            alert(data.description);
            //button.removeAttribute('disabled')
            //button.classList.remove('disabled')
          }

          window.location.href = "/cart";
        })
        .finally(() => {})
        .catch((error) => {
          button.removeAttribute("disabled");
          button.classList.remove("disabled");
          console.error("Error:", error);
        });
    });
  });
